<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <el-card class="w-full max-w-md mx-4 shadow-lg">
      <template #header>
        <h2 class="text-xl font-bold text-center text-gray-800">管理员登录</h2>
      </template>

      <el-form ref="formRef" :model="loginForm" :rules="rules" @submit.prevent="handleLogin" class="space-y-6">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            :prefix-icon="User"
            placeholder="请输入用户名"
            :disabled="loading"
            @keyup.enter="handleEnterPress"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            :prefix-icon="Lock"
            type="password"
            placeholder="请输入密码"
            show-password
            :disabled="loading"
            @keyup.enter="handleEnterPress"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            native-type="submit"
            :loading="loading"
            class="w-full"
            :disabled="!loginForm.username || !loginForm.password"
          >
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { User, Lock } from '@element-plus/icons-vue'
import { authApi } from '../api'

const router = useRouter()
const formRef = ref(null)
const loading = ref(false)
const loginForm = ref({
  username: '',
  password: '',
})

// 表单验证规则
const rules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 3, max: 20, message: '用户名长度应在 3 到 20 个字符之间', trigger: 'blur' },
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度应在 6 到 20 个字符之间', trigger: 'blur' },
  ],
}

// 处理回车键
const handleEnterPress = () => {
  if (loginForm.value.username && loginForm.value.password) {
    handleLogin()
  }
}

// 登录处理
const handleLogin = async () => {
  if (!formRef.value) return

  try {
    // 表单验证
    await formRef.value.validate()

    // 开始登录
    loading.value = true
    const { token, user } = await authApi.login({
      username: loginForm.value.username,
      password: loginForm.value.password,
    })

    // 保存登录信息
    localStorage.setItem('token', token)
    localStorage.setItem('user', JSON.stringify(user))

    ElMessage.success('登录成功')
    router.push('/documents')
  } catch (error) {
    // 显示错误信息
    const message = error.response?.data?.message || '登录失败，请检查用户名和密码'
    ElMessage.error(message)
  } finally {
    loading.value = false
  }
}
</script>
